import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { userModule } from "@/store/modules/user";
import Billing from "@/services/Billing";

class LockingRegister {
  
  get register(){
    return RegisterKunjungan.register;
  }
  get stateuser() {
    return userModule.user;
  }

  unlockRegister(aplikasi:any) {
    if (this.register) {
      const dt = Billing.unlockRegister(this.register["no"], this.stateuser.id, aplikasi);
      dt.then((dt) => {
        if (dt.status != 1) {
          // appModule.sendErrorAlert(dt.message);
        }
      });
    }
  }
}

export default new LockingRegister();
